export default __webpack_public_path__ + "static/media/SJA1510.34I-42082_-25228_0.ff93a068.jpg";